import ChunkCarousel from './ChunkCarousel';

export default ChunkCarousel;
